import React, { useState, useEffect } from "react";
// componentes
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Collapse,
} from "reactstrap";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import SearchFilters from "../../../components/SearchFilters";
import Pagination from "../../../components/Paginationv3";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";
import WaitExport from "../../../components/WaitExport";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import ModalNewSpeaker from "./ModalNewSpeaker";
import ModalEditSpeaker from "./ModalEditSpeaker";
import ModalImportWrapper from "./ModalImportWrapper";
// rotas
import { useLocation } from "react-router-dom";
// redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
// hooks
import useDebounce from "../../../utils/hooks/useDebounce";
// services
import {
  deleteSpeaker,
  deleteAllSpeaker,
  getAllSpeakers,
} from "../../../utils/services/speaker";
// utils
import { createXlsx } from "./createXlsx";

function Speaker(props) {
  // state de collapses
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);

  // state de alerta de exclusão
  const [confirmAlert, setConfirmAlert] = useState(false);
  const [deleteError, setDeleteError] = useState("");

  // state de busca e filtro
  const [search, setSearch] = useState("");
  const [activeFilter, setActiveFilter] = useState("name");
  const debouncedSearch = useDebounce(search, 300);

  // state de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [countData, setCountData] = useState(0);

  // state de modais
  const [modalNewSpeaker, setModalNewSpeaker] = useState(false);
  const [modalEditSpeaker, setModalEditSpeaker] = useState(false);
  const [modalImportWrapper, setModalImportWrapper] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);

  // state de dados selecionados
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});

  // state de dados da tabela
  const [speakers, setSpeakers] = useState([]);
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  // state de loading
  const [loading, setLoading] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  // state de exportação
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);

  const columnsFilter = [
    { name: "Nome", value: "name", type: "text" },
    {
      name: "Empresa / Cargo / Especialidade",
      value: "position",
      type: "text",
    },
    { name: "Categoria", value: "category", type: "text" },
  ];
  const location = useLocation();
  const idEvent = location.state.idEvent;

  // altera o filtro de busca ativo e limpa o texto pesquisado
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // busca a listagem de palestrantes
  function getAll() {
    setLoading(true);
    getAllSpeakers(
      idEvent,
      currentIndex,
      itemsPerPage,
      debouncedSearch,
      activeFilter,
    ).then((res) => {
      if (res.data.message === "findAllPalestrantes") {
        setSpeakers(res.data.findAllPalestrantes.data);
        setCountData(res.data.findAllPalestrantes.count);
      } else {
        toast.error("Erro ao buscar palestrantes.");
      }
      setLoading(false);
    });
  }
  useEffect(() => {
    getAll();
  }, [currentIndex, itemsPerPage, debouncedSearch, activeFilter]);

  // abre/fecha o modal de criação e atualiza a listagem ao fechar
  function toggleNewSpeaker() {
    setModalNewSpeaker(!modalNewSpeaker);
    if (modalNewSpeaker) {
      getAll();
    }
  }

  // abre/fecha o modal de edição e atualiza a listagem ao fechar
  function toggleEditSpeaker() {
    setModalEditSpeaker(!modalEditSpeaker);
    if (modalEditSpeaker) {
      getAll();
    }
  }

  // deleta um palestrante
  async function delSpeaker() {
    if (deleteData?.id) {
      const res = await deleteSpeaker(deleteData.id);
      setConfirmAlert(false);
      if (res.message === "deleted") {
        setSuccessDelete(true);
      } else {
        setDeleteError("Erro ao deletar palestrante.");
      }
    }
  }

  // deleta todos os palestrantes do evento
  async function delAllSpeaker() {
    const res = await deleteAllSpeaker(idEvent);
    if (res.message === "deleted") {
      setSuccessDelete(true);
    } else {
      setDeleteError("Erro ao deletar todos os palestrantes.");
    }
  }

  // abre/fecha o modal de importação
  function toggleImportWrapper() {
    setModalImportWrapper(!modalImportWrapper);
  }
  return (
    <>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Palestrantes"
          onConfirm={delAllSpeaker}
        />
      )}

      {modalNewSpeaker && (
        <ModalNewSpeaker
          isOpen={modalNewSpeaker}
          toggle={toggleNewSpeaker}
          idEvent={idEvent}
        />
      )}
      {modalEditSpeaker && (
        <ModalEditSpeaker
          isOpen={modalEditSpeaker}
          toggle={toggleEditSpeaker}
          idEvent={idEvent}
          data={editData}
        />
      )}
      {confirmAlert ? (
        <SweetAlert
          title={`Deseja deletar o(a) palestrante ${deleteData.name}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            delSpeaker();
          }}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação!
        </SweetAlert>
      ) : null}

      {successDelete ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            getAll();
            setSuccessDelete(false);
          }}
        >
          Palestrante(s) Deletado(s) com sucesso
        </SweetAlert>
      ) : null}

      {deleteError && (
        <SweetAlert danger title="Erro" onConfirm={() => setDeleteError("")}>
          {deleteError}
        </SweetAlert>
      )}

      <WaitExport
        isOpen={exportInProgress}
        name="Palestrantes"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <ModalImportWrapper
        isOpen={modalImportWrapper}
        toggle={toggleImportWrapper}
        getAllSpeakers={getAll}
        idEvent={idEvent}
      />
      <Card>
        <CardBody>
          <CardTitle>Palestrantes</CardTitle>

          <div>
            <Row
              style={{
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName={"Filtros"}
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>

            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>

          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>

            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />

              <Collapse isOpen={isOpen}>
                {speakers.length > 0 && (
                  <Row className="mobile-btns-top" style={{ marginTop: 5 }}>
                    <div
                      onClick={() => {
                        createXlsx({
                          idEvent: idEvent,
                          limit: 100,
                          countData,
                          setFinishExport,
                        });
                        setExportInProgress(true);
                      }}
                    >
                      Exportar Palestrantes
                    </div>
                  </Row>
                )}
                <ActionButtonRounded
                  title="Importar Palestrantes"
                  type="mobile"
                  onClick={() => toggleImportWrapper(true)}
                />

                <ActionButtonRounded
                  title="Adicionar Palestrante"
                  type="mobile"
                  onClick={() => setModalNewSpeaker(true)}
                />
              </Collapse>
            </div>

            <div className="header-btns-container">
              {speakers.length > 0 && (
                <Button
                  style={{ marginRight: 5 }}
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => {
                    createXlsx({
                      idEvent: idEvent,
                      limit: 100,
                      countData,
                      setFinishExport,
                    });
                    setExportInProgress(true);
                  }}
                >
                  Exportar Palestrantes
                </Button>
              )}
              <ActionButtonRounded
                title="Importar Palestrantes"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                onClick={() => toggleImportWrapper(true)}
              />

              <ActionButtonRounded
                title="Adicionar Palestrante"
                className="btn-rounded waves-effect waves-light events-button-add-lg"
                margin="0 0 0 5px"
                onClick={() => setModalNewSpeaker(true)}
              />
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Nome</th>
                  <th>Empresa / Cargo / Especialidade</th>
                  <th>Categoria</th>
                  <th>Ordem</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : (
                  speakers.length > 0 &&
                  speakers.map((e) => (
                    <tr key={e.id}>
                      <td>{e.name}</td>
                      <td>{e.position}</td>
                      <td>{e.category}</td>
                      <td>{e.order}</td>

                      <td>
                        <i
                          className="mdi mdi-pencil"
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setEditData(e);
                            setModalEditSpeaker(true);
                          }}
                          title="Editar"
                        />
                        <DeleteButton
                          onClick={() => {
                            setDeleteData(e);
                            setConfirmAlert(true);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            speakers?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {speakers.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Palestrantes"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        <Pagination
          data={speakers}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Speaker);
